import { ActionTypes as NavBarActionTypes } from 'ha/modules/NavBar/actions';
import { AnyAction } from 'redux';
import { CHANGE_MODAL_TYPE } from './actions';

const initialState = {
  modalType: 'login',
  returnUrl: '',
  options: {},
};

export default function reducer(state = initialState, action: AnyAction) {
  switch (action.type) {
    case CHANGE_MODAL_TYPE: {
      return {
        ...state,
        modalType: action.payload.modalType,
      };
    }
    case NavBarActionTypes.SHOW_MODAL: {
      return {
        ...state,
        modalType: action.payload.modalType || state.modalType,
        returnUrl: action.payload.returnUrl,
        options: action.payload.options,
      };
    }
    default:
      return state;
  }
}
